import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../root-redux/RootState";
import { setShowApprovalDetailsPanel, setApprovalDetailsInSummary } from "../ReleaseData.redux";
import { Button, DataGrid, Dialog, InlineStatus, ProgressRing } from "../../spa-admin/SpaAdminScope";
import { getConfigurationByIdandVersion_uat, postConfigurationDetailsForRelease } from './ConfigurationApi';
import {  RenderProdOnlyReleaseFields, validateField } from '../../spa-admin/edit-campaign/Components/ConfigRenderer';
import { taxonomySelector } from '../../spa-admin/redux/Taxonomy.selector.redux';
import { Helper } from "../../spa-admin/utils/Help";
import { Attribute } from "../../../model/preview-mergerule/Prediction.model";
import { CAMPAIGN_APPROVED_BY_FIELD, CampaignStatusEnum, ConfigurationType } from "../../spa-admin/SPAConstants";
import { getApproverObjectByIdOrName } from "../../../services/SPAAdmin/SPAUserObjects.api";
import { Spinner } from "../../../shared-components/loader/Spinner";
import { setCampaignSummary } from "../../spa-admin/redux/CampaignById.redux";
import { getUatReleasesForConfiguration } from "../../../services/GetReleases.api";

export const ApprovalDetailsPROD: React.FC<any> = React.memo((props: any) => {

        const dispatch = useDispatch<AppDispatch>();
        const uatConfiguration = useSelector((state: RootState) => state.releaseData.uatConfiguration);//later change this to uat 
        const showApprovalDetails = useSelector((state: RootState) => state.releaseData.showConfigurationApprovalDetailsPanel);
        const campaignConfig = useSelector((state: RootState) => state.campaignConfig);
        const [isFormValid, setIsFormValid] = useState<boolean>(false);
        const taxonomyState = useSelector(taxonomySelector);
        const approvalCheckEnv = "uat";//"dev";// later change this to uat
        const selectedVersion=props.selectedVersion;
        const [showApprovedByLoading, setShowApprovedByLoading] = useState<boolean>(false);
        const [approverName, setApproverName] = useState<string|undefined>(undefined);

        const [proceedClicked,setProceedClicked] = useState<boolean>(false);
        const [isValidApprover,setIsValidApprover] = useState<boolean>(false);
        const [showError,setShowError] = useState<boolean>(false);
        const campaignUserObjectsState = useSelector((state: RootState) => state.spaUserObjects);

        useEffect(() => {
               let isValid = true;
                    for(const layoutField of (campaignConfig.campaignConfig?.layoutFields || [])) {
                        if (layoutField.requiredOnlyForProd === true && !validateField(layoutField.regex,getValueFromSummaryByKey(layoutField.name) )) {
                            isValid = false;
                            break;
                        }
                    }
                    setIsFormValid(isValid);
        },[campaignConfig,uatConfiguration.summary])
        
//Converting the approved by field to user name for the first time
        // useEffect(() => {
        //     if(selectedVersion && selectedVersion.length > 0) {
        //     const approverAttribute = uatConfiguration.summary?.find((item: Attribute) => item.key === CAMPAIGN_APPROVED_BY_FIELD);
        //     if(approverName === undefined && approverAttribute?.value?.length > 0 ) {
        //         setShowApprovedByLoading(true);
        //         dispatch(getApproverObjectByIdOrName(approverAttribute.value)).unwrap().then((result) => {
        //             if (result && result[0] && result[0].id) {
        //                 const aname = result[0].userPrincipalName.substring(0, result[0].userPrincipalName.indexOf("@"));
        //                 setApproverName(aname);
        //                 dispatch(setApprovalDetailsInSummary({ key: CAMPAIGN_APPROVED_BY_FIELD, value: aname }));
        //                 //  dispatch(setCampaignSummary({ key: CAMPAIGN_APPROVED_BY_FIELD, value: result[0].userPrincipalName.substring(0, result[0].userPrincipalName.indexOf("@")) }));
        //                 setShowApprovedByLoading(false);
                        
        //             }
        //         });
        //     } 
        //     else if (approverName !== undefined && !proceedClicked) {
        //         dispatch(setApprovalDetailsInSummary({ key: CAMPAIGN_APPROVED_BY_FIELD, value: approverName }));
        //         setShowApprovedByLoading(false);
        //     }
        // }
        // },[uatConfiguration]);


        //Everytime when the Proceed button is clicked, we need to check if the approver is valid or not
        //If valid, then we need to post the configuration to the uat environment
        useEffect(() => {
            if (isValidApprover) {

                const updatedConfiguration = {...uatConfiguration,status:uatConfiguration.status!=CampaignStatusEnum.PUBLISHED?CampaignStatusEnum.PUBLISHED:uatConfiguration.status, environment: approvalCheckEnv,dontUpdateModifiedDate: true };
                dispatch(postConfigurationDetailsForRelease({...updatedConfiguration,env: approvalCheckEnv })).unwrap().then((response) => {   
                    //change this to prod
                        dispatch(setShowApprovalDetailsPanel(false));
                        setShowApprovedByLoading(false);
                        props.setProceedWithDeploy(true);
                        setProceedClicked(false);
                });
            }
        }, [isValidApprover]);

        const getValueFromSummaryByKey = (key: string) => {
            const summary = uatConfiguration.summary?.find((item: Attribute) => item.key === key);
            return summary ? summary.value : null;
        }

        const handleRequestClose = (event: any) => {
                
                dispatch(setShowApprovalDetailsPanel(false));
               
        }
        const onNextClick = () => {
            
            setShowApprovedByLoading(true);
            const updatedConfiguration = {...uatConfiguration,status:uatConfiguration.status!=CampaignStatusEnum.PUBLISHED?CampaignStatusEnum.PUBLISHED:uatConfiguration.status, environment: approvalCheckEnv,dontUpdateModifiedDate: true };
            dispatch(postConfigurationDetailsForRelease({...updatedConfiguration,env: approvalCheckEnv })).unwrap().then((response) => {   
                //change this to prod
                    dispatch(setShowApprovalDetailsPanel(false));
                    setShowApprovedByLoading(false);
                    props.setProceedWithDeploy(true);
                    setProceedClicked(false);
            });
            //Check for Approved By validity
            // const approvedByAlias = getValueFromSummaryByKey(CAMPAIGN_APPROVED_BY_FIELD);
            // const approvedBy = approvedByAlias.concat("@microsoft.com");
            // setShowError(false);
            // setProceedClicked(true);
            // setApproverName(approvedByAlias);
            // setShowApprovedByLoading(true);
            // dispatch(getApproverObjectByIdOrName(approvedBy)).unwrap().then((result) => {
            //     if (result && result[0] && result[0].id) { 
            //         dispatch(setApprovalDetailsInSummary({ key: CAMPAIGN_APPROVED_BY_FIELD, value: result[0].id }));
            //         setIsValidApprover(true);
            //     } else {
            //         setIsFormValid(false);
            //         setProceedClicked(false);
            //         setShowApprovedByLoading(false);
            //         setShowError(true);
            //         return;
            //     }
            // }).catch((error) => {
            //     setIsFormValid(false);
            //     setShowError(true);
            //     setShowApprovedByLoading(false);
            //     setProceedClicked(false);
            //     return;
            // })
        
        }
        const handleApprovalFormChange = (e: any) => {
                // Add your logic here for handling summary form changes
                 if (e.target.tagName && e.target.tagName.toUpperCase().search("DATE-PICKER") !== -1) {
                            if( e.target.value && e.target.value.length > 0) {
                                const darr = e.target.value.split('-');
                                const value = `${darr[1]}/${darr[2]}/${darr[0]}`;
                                dispatch(setApprovalDetailsInSummary({ key: e.target.name, value: value}));
                            }else {
                                dispatch(setApprovalDetailsInSummary({ key: e.target.name, value: "" })); //Empty value applies when datepicker is cleared
                            }
                        } else {
                            const keyName = e.target.name;
                            let value = (e.target.value || "").trim();
                            value = value.replaceAll(new RegExp("\\$","g"),"$$$$"); //replace $ with $$ for escape character
                            value = value.replaceAll("'", "\\\\'");
                            value = value.replaceAll('\\r', '\n').replaceAll('\\n', '\n').replaceAll('\\r\\n', '\n');
                            value = value.split('\n').map((str: string) => str.trim()).filter((str: string) => str.length > 0 || keyName === 'RecommendationTitle').join('\n').replaceAll('\n', '\\\\\\\\r\\\\\\\\n');
                            const isuuid = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(e.target.value); // Check if value is a valid UUID
                            // if (e.target.name === CAMPAIGN_APPROVED_BY_FIELD && !isuuid) { //Setting it only if it is not a uuid
                            //         setApproverName(value);
                            // }
                            dispatch(setApprovalDetailsInSummary({ key: keyName, value: value }));
                        }
                      setShowError(false);
                return true;
        }
         return (
            
                    <Dialog
                    style={{width: 'auto'}}
                    heading={`Please Provide or Validate the Approval Information  ${uatConfiguration?.config?.workflowName}`}
                    open={showApprovalDetails}
                    onHeRequestClose={handleRequestClose}
                    className="release-diff-dialog"
                    > 

            
                
                    <table className='workflow-form-table  workflow-basics-table' role='presentation' style={{marginBottom: '80px'}}>
                            <RenderProdOnlyReleaseFields section={2} taxonomyState={taxonomyState} selectionChange={handleApprovalFormChange} layoutConfigs={campaignConfig.campaignConfig?.layoutFields} summary={Helper.fetchCampaignFieldsToSummary(uatConfiguration)??{}} editCampaignFlag={false} campaignUserObjectsState={campaignUserObjectsState} />
                            <Button type='button' appearance='primary' onClick={onNextClick} disabled={!isFormValid}>Proceed</Button> 
        
                    </table>
                    {/* <div className='spa-progressring' hidden={!showApprovedByLoading}>
                                    <ProgressRing label="Loading..." indeterminate></ProgressRing>
                    </div> */}
                  
            {/* {showError &&(
                    <div  >
                    
                          <InlineStatus type="error">
                            <b>Approver</b>: {getValueFromSummaryByKey(CAMPAIGN_APPROVED_BY_FIELD)} is invalid.
                          </InlineStatus>
                          <p>Please add valid Approver alias for CA to be published to Production.</p>
                       
                    </div>
            )} */}
                  </Dialog>

        )
    }
)